import React, { Component } from "react";
import { connect } from "react-redux";
import { setMakerCollateral } from "../../../../actions/ui/marketplace";
import { removeTaker } from "../../../../actions/orderbook/matchingEngine";
import { lowestDenom, tokenDictionary, toUnit, fromUnit } from "../../../../config";
import $ from "jquery";
import { Decimal } from "decimal.js";

class TakeOrders extends Component {
  constructor() {
    super();
    this.state = { amount: 0, to: 0, name: "BTC" };
  }
  onClick(index) {
    if(this.props.receivesToChain.toLowerCase() != 'nrg' && this.props.sendsFromChain.toLowerCase() != 'nrg') this.props.removeTaker(index);
  }
  item(key,val){
    return (
      <div className="row mi">
        <h6 className='leftInfo'>{key}</h6>
        <h6 className="rightInfo">{val}</h6>
      </div>
    )
  }
  maker(){
    if (this.props.makerAmount && this.props.price != 0) {

      let settleLeft = `in ${this.props.settlement} Blocks`;
      if (tokenDictionary[this.props.sendsFromChain.toLowerCase()].toUpperCase() !== "BC"){
        settleLeft += ` + ${this.props.shiftMaker + 1} ${tokenDictionary[this.props.sendsFromChain.toLowerCase()].toUpperCase()} Block`;
      }
      if (tokenDictionary[this.props.sendsFromChain.toLowerCase()] != tokenDictionary[this.props.receivesToChain.toLowerCase()]) {
        settleLeft += ` + ${this.props.shiftTaker + 1} ${tokenDictionary[this.props.receivesToChain.toLowerCase()].toUpperCase()} Blocks`;
      }

      return (
        <>
          {this.item("Type","Maker")}
          {this.item("Send",`${this.props.sendsUnit} ${this.props.sendsFromChain.toUpperCase().replace('NRG','OL')}`)}
          {this.item("Receive",`${this.props.receivesUnit} ${this.props.receivesToChain.toUpperCase().replace('NRG','OL')}`)}
          <div className="row mi">
            <h6 className='leftInfo'>
              {this.props.sendsFromChain == "NRG" || this.props.receivesToChain == "NRG" ? "Initial Taker Collateral" : `Collateral`}
            </h6>
            <h6 className='rightInfo'>OL</h6>
            <input placeholder={'Input Amount'} id="makerInput" onChange={this.onChange.bind(this)} type={"number"} min={0} style={{textAlign:'right',borderBottom:'0',width:'50%',float: "right",marginTop: "5px",fontFamily: "Gilmer-Light", letterSpacing: "0.5px"}}/>
          </div>
          {this.item('Trade Lifespan',`in ${this.props.deposit} Blocks`)}
          {this.item('Settlement',settleLeft)}
          {this.props.takeOrders.length > 0 && <div className="row mi"> <hr/> </div>}
        </>
      );
    }
    else return null;
  }
  taker() {
    return this.props.takeOrders.map(({fixedUnitFee, receivesToChain, sendsFromChain, sendAmount, recAmount, amount, price, id, cml, takeAmount, collateralizedNrg, depositLeft, settleLeft},i) => {
        if (takeAmount === null || takeAmount == 0) takeAmount = amount;
        let modifiedCollateral = new Decimal(collateralizedNrg).mul(new Decimal(takeAmount)).div(new Decimal(amount)).toNumber();
        if (fixedUnitFee !== "0") modifiedCollateral = new Decimal(fixedUnitFee).toNumber();
        return (
          <>
            {this.item("Type","Taker")}
            {this.item("Send",`${sendAmount} ${this.props.sendsFromChain.toUpperCase()}`)}
            {this.item("Receive",`${recAmount} ${this.props.receivesToChain.toUpperCase()}`)}
            {this.item(`Collateral`,`${modifiedCollateral} NRG`)}
            {this.item('Trade Lifespan',depositLeft)}
            {this.item('Settlement',settleLeft)}
            {i+1 != this.props.takeOrders.length && <div className="row mi"> <hr/> </div>}
          </>
        );
      }
    );
  }
  render() {
    return (
      <div>
        {this.maker()}
        {this.taker()}
      </div>
    );
  }
  onChange(e) {
    this.props.setMakerCollateral(e.target.value, () => {});
  }
  componentDidUpdate(props) {
    let input = $("#makerInput")[0];
    if (input && (input.value == "" || props.makerCollateral != this.props.makerCollateral)) {
      input.value = this.props.makerCollateral;
    }
  }
}

function mapStateToProps(state, props) {
  let { denomination, asset, type } = state.ui_marketplace.market;
  let sendsFromChain = state.ui_marketplace.orderType === "BUY" ? denomination : asset;
  let receivesToChain = state.ui_marketplace.orderType === "BUY" ? asset : denomination;
  let price = state.ui_marketplace.price ? state.ui_marketplace.price : 0;
  let makerAmount = state.ui_marketplace.makerAmount;
  let receivesUnit = state.ui_marketplace.orderType == "BUY" ? makerAmount : new Decimal(makerAmount).mul(new Decimal(price)).toNumber();
  let sendsUnit = state.ui_marketplace.orderType == "SELL" ? makerAmount : new Decimal(makerAmount).mul(new Decimal(price)).toNumber();

  sendsUnit = fromUnit(sendsFromChain.toLowerCase(),Math.floor(toUnit(sendsFromChain.toLowerCase(),sendsUnit)))
  receivesUnit = fromUnit(receivesToChain.toLowerCase(),Math.floor(toUnit(receivesToChain.toLowerCase(),receivesUnit)))

  if(sendsUnit === 0 || receivesUnit === 0) makerAmount = 0;

  return {
    market: state.ui_marketplace.market,
    orderType: state.ui_marketplace.orderType,
    price: state.ui_marketplace.price,
    amount:state.ui_marketplace.amount,
    makerAmount: makerAmount,
    settlement: state.settings.settings.settlement,
    deposit: state.settings.settings.deposit,
    shiftMaker: state.settings.settings.shiftMaker,
    shiftTaker: state.settings.settings.shiftTaker,
    receivesUnit,
    sendsUnit,
    sendsFromChain,
    receivesToChain,
    makerCollateral: state.ui_marketplace.makerCollateral,
    spending: state.ui_marketplace.spending,
    takeOrders: state.ui_marketplace.takeOrders
  };
}

export default connect(mapStateToProps,{ setMakerCollateral, removeTaker })(TakeOrders);
